import { LEFT_PANEL_ELEMENT_ID, LEFT_PANEL_OVERLAY_ID } from '../constant';

export const getLeftPanelOverlapRatio = (canvasElement: HTMLCanvasElement): number => {
  const TAB_TOGGLE_WIDTH = 20;
  const tabEndX = document.getElementById(LEFT_PANEL_ELEMENT_ID)?.getBoundingClientRect().right;
  const overlayEndX = document.getElementById(LEFT_PANEL_OVERLAY_ID)?.getBoundingClientRect().right;

  const overlapEndX = Math.max((tabEndX || 0) + TAB_TOGGLE_WIDTH, overlayEndX || 0);
  const canvasRect = canvasElement.getBoundingClientRect();
  const screenOverlapWidth = overlapEndX - canvasRect.left;
  if (screenOverlapWidth > 0) {
    const overlapRatio = screenOverlapWidth / canvasRect.width;
    return overlapRatio;
  }
  return 0;
};
